import { GlobalContants, PageTitle, Resource } from 'src/app/constants/global.contants';
import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  // {
  //   displayName: 'Dashboard',
  //   iconName: 'layout-dashboard',
  //   bgcolor: 'warning',
  //   route: '/home/dashboard',
  // },
  {
    displayName: 'Generate API Key',
    iconName: 'rosette',
    bgcolor: 'warning',
    route: '/home/generate-api-key',
  },
  {
    displayName: 'Authentication',
    iconName: 'poker-chip',
    bgcolor: 'warning',
    route: '/home/authentication-api',
  },
  {
    navCap: 'API Services',
  },
  {
    displayName: 'API Document',
    iconName: 'api-app',
    bgcolor: 'warning',
    route: '',
    children: [
      {
        show: false,
        resource_name: Resource.AvmData,
        displayName: PageTitle.avmGroup,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.AvmGgroup,
      },
      {
        show: false,
        resource_name: Resource.avmCalculator,
        displayName: PageTitle.avmCalculator,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.avmCalculator,
      },
        {
        show: false,
        resource_name: Resource.nearby,
        displayName: PageTitle.nearbyApi,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.nearbbyApi,
      },
      {
        show: false,
        resource_name: Resource.NearbyData,
        displayName: PageTitle.nearbyGroup,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.NearbyGroup,
      },
      {
        show: false,
        resource_name: Resource.OfficeProperty,
        displayName: PageTitle.commercialData,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.CommercialData,
      },
      {
        show: false,
        resource_name: Resource.AvmRental,
        displayName: PageTitle.avmRental,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.AvmRental,
      },
      {
        show: false,
        resource_name: Resource.CommercialRental,
        displayName: PageTitle.commercialRental,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.CommercialRental,
      },
      {
        show: false,
        resource_name: Resource.AvmApi,
        displayName: PageTitle.avmApi,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.AvmApi,
      },
       {
        show: false,
        resource_name: Resource.Building,
        displayName: PageTitle.buildings,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.Buildings,
      },
       {
        show: false,
        resource_name: Resource.Floor,
        displayName: PageTitle.floor,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.Floor,
      },
       {
        show: false,
        resource_name: Resource.Unit,
        displayName: PageTitle.unit,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.Unit,
      },
       {
        show: false,
        resource_name: Resource.Transaction,
        displayName: PageTitle.transaction,
        iconName: 'http-get',
        bgcolor: 'default',
        route: '/home/'+GlobalContants.Routes.Transaction,
      },
    ]
  }
];
